import API from 'constants/api';
import { SET_VALUE, ADD_VALUE, REMOVE_VALUE, 
  ADD_ENUM_OPTIONS, TOGGLE_ADD_FIELD, TOGGLE_ALLOW_FIELD } from 'constants/actionTypes';
import { valueToOption } from 'helpers/objectHelpers';

export const setValue = (predicate, index, value) => dispatch => {
  dispatch({
    type: SET_VALUE,
    predicate,
    index, // values[index] = value
    value
  });
};

export const addValue = (predicate, value) => dispatch => {
  dispatch({
    type: ADD_VALUE,
    predicate,
    value
  });
};

export const removeValue = (predicate, index) => dispatch => {
  dispatch({
    type: REMOVE_VALUE,
    predicate,
    index
  });
};

export const setEnums = (enums) => dispatch => {
  dispatch({
    type: ADD_ENUM_OPTIONS, enums
  });
};

/**
 * Load options for react-select
 * @param {*} predicate maps to Resource of ModifiableEnumeration type
 */
export const loadEnum = predicate => {
  return fetch(`${API.UI.ENUM}&predicate=${predicate}`)
    .then(res => res.json())
    .then(values => {
      return {
        predicate, options: values.map(valueToOption)
      };
    });
};

/**
 * Load options for all select menus' when opening an object
 * or Resource in modal
 * 
 * @param {*} fields for Resource or Object 
 */
export const loadEnums = (fields) => dispatch => {
  let enums = [];

  for (let field of fields) {
    if (field.props.enum) {
      enums.push(`predicates=${field.predicate}`);
    }
  }

  if (enums.length > 0) {
    fetch(`${API.UI.ENUMS}&${enums.join('&')}`)
      .then(res => res.json())
      .then(enumMap => {
        const options = [];
        // map Enums (Value.java) into react-select options
        Object.keys(enumMap).forEach(p => {
          options[p] = enumMap[p].map(valueToOption);
        });
        dispatch({ type: ADD_ENUM_OPTIONS, enums: options });
      });
  }
};

export const toggleAllow = predicate => dispatch => {
  dispatch({ type: TOGGLE_ALLOW_FIELD, predicate });
};

export const toggleAdd = predicate => dispatch => {
  dispatch({ type: TOGGLE_ADD_FIELD, predicate });
};

// Sets allowed if not already
export const setAllowed = predicate => (dispatch, getState) => {
  const allowed = getState().massedit.allowed[predicate];
  if (!allowed) {
    dispatch(toggleAllow(predicate));
  }
};